export default __webpack_public_path__ + "static/media/ttaQualifiedBadge.5d8ed947.svg";